import { render, staticRenderFns } from "./MedicalRecordEntryDashboard.vue?vue&type=template&id=7d153986&"
import script from "./MedicalRecordEntryDashboard.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordEntryDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports